import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {getGridApi} from 'ag-grid-community';
import {useSetWidgetAttribute} from '../../hooks/useSetWidgetAttribute.js';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';
import WidgetTitleSettings from '../../settings_sidebar/WidgetTitleSettings.jsx';
import ToggleSwitch from '../../../common/ToggleSwitch.jsx';
import commonStyles from '../base/CommonSettings.module.scss';

function WorkflowInboxWidgetSettings({widgetId}) {
  const setAttribute = useSetWidgetAttribute(widgetId);
  const projectFilterEnabled = useSelector(state => state.dashboard.widgets[widgetId].settings?.projectFilterEnabled ?? false);
  const gridId = `workflow-inbox-grid-widget-${widgetId}`;
  const gridAdvancedFilterId = `workflow-inbox-advanced-filter-${widgetId}`;
  const gridApi = getGridApi(gridId);

  useEffect(() => {
    const filterContainer = document.getElementById(gridAdvancedFilterId);
    gridApi.setGridOption('advancedFilterParent', filterContainer);
    gridApi.setGridOption('popupParent', filterContainer);

    gridApi.addEventListener('filterChanged', onAdvancedFilterChanged);
  }, []);

  const onAdvancedFilterChanged = (params) => {
    const model = params.api.getAdvancedFilterModel();
    setAttribute('settings.advancedFilterModel', model);
  };

  return (<>
    <hr/>
    <label className='mt-1'>{I18n.t('filters')}</label>
    <div id={gridAdvancedFilterId}/>

    <CollapsibleSection title={I18n.t('content_settings')}>
      <WidgetTitleSettings widgetId={widgetId}/>

      <fieldset>
        <div className={`${commonStyles['settings-section']} flex-dir-row justify-content-space-between mb-1`}>
          <label>{I18n.t('project_filter_enabled')}</label>
          <ToggleSwitch
            name='project_filter_enabled'
            isOn={projectFilterEnabled}
            defaultIsOn={projectFilterEnabled}
            handleToggle={() => setAttribute('settings.projectFilterEnabled', !projectFilterEnabled)}
          />
        </div>
      </fieldset>
    </CollapsibleSection>
  </>);
};

export default WorkflowInboxWidgetSettings;
